// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"699":"e8d9e757","939":"b00c9dd5"}[chunkId] + ".chunk.css";
};